module.exports = __webpack_public_path__ + "img/2024-02-13f_2.03c777cd.jpg";